import React from 'react'
import style from './scroll-down.mod.scss'
import Arrow from '@svgs/arrow.svg'
import Scroll from '@helpers/scroll'
import { Button } from '@components'

const ScrollDown = ({ element = '', type = '' }) => {
  return (
    <div className={style['scroll-down']}>
      <Scroll type={type} element={element}>
        <Button to={element} unstyled title={`Scroll to ${element}`}>
          <Arrow />
        </Button>
      </Scroll>
    </div>
  )
}

export default ScrollDown
